module.exports = require("lodash.get");


//////////////////
// WEBPACK FOOTER
// external "lodash.get"
// module id = 3
// module chunks = 0